export const numberW = 25;
export const selectW = 20;
export const emailW = 260;
export const firstNameW = 140;
export const lastNameW = 140;
export const vendorW = 200;
export const roleW = 160;
export const toolW = 160;
